import { PaymentType } from 'core/payments/entities';
import { FeatureDefinition } from '../entities';

export const paymentActiveProvidersFeature = 'appnebula_payment_active_providers';

export type PaymentActiveProvidersFeatureValue = {
  paymentForm: {
    card: boolean;
    paypal: boolean;
    apple_pay: boolean;
    google_pay: boolean;
    pix: boolean;
  };
  defaultMethod: PaymentType;
};

export const paymentActiveProvidersDefaultValue: PaymentActiveProvidersFeatureValue = {
  paymentForm: {
    card: true,
    paypal: false,
    apple_pay: true,
    google_pay: true,
    pix: false,
  },
  defaultMethod: PaymentType.CARD,
};

export const paymentActiveProvidersFeatureConfig: FeatureDefinition<PaymentActiveProvidersFeatureValue> =
  {
    defaultValue: paymentActiveProvidersDefaultValue,
  };
